module.exports = __webpack_public_path__ + "static/media/6-20.94a38e01.svg";